import { COLORS } from "../../styles/variables"

export const StyledBox = {
  display: 'flex', 
  flexDirection: 'column', 
  minHeight: '100vh', 
  background: COLORS.SNOW_DRIFT,
}

export const StyledContainer = {
  maxWidth: '1112px',
  padding: '50px 0px 0px 0px',
}
